import React, { useState } from 'react';
import { AllRefresh } from '@vtbhome/juicyfront/indexIcon';
import { RequestEmailBtnProps } from './types';
import { useTimer } from '@shared/lib/hooks/use-timer/use-timer';
import { REQUEST_EMAIL_TIMER_KEY } from '../../config/form-register-constants';
import { Button } from '@vtbhome/juicyfront';

export const RequestEmailBtn: React.FC<RequestEmailBtnProps> = ({
    disabled,
    preloader,
    isSuccessRequestedAgain,
    isNotVerifiedRoute = false,
    onClick,
}) => {
    const [timerAfterClick, setTimerAfterClick] = useState(isNotVerifiedRoute);

    const { isTimerEnd, formatValue } = useTimer({
        timerKey: REQUEST_EMAIL_TIMER_KEY,
        restartDependancy: isSuccessRequestedAgain,
        runTimerAfterClick: timerAfterClick,
    });

    const handleClick = () => {
        setTimerAfterClick(false);
        onClick();
    };

    return (
        <Button
            type='button'
            size='m'
            buttonType='light'
            startAdornment={<AllRefresh />}
            fullWidth={false}
            disabled={!isTimerEnd || disabled}
            preloader={preloader}
            onClick={handleClick}>
            {isTimerEnd ? !preloader && 'Запросить заново' : formatValue}
        </Button>
    );
};
